module.exports = __webpack_public_path__ + "static/media/Logo.d9d6698e.png";